import Description from "@/partials/elements/Description";
import Headline from "@/partials/elements/Headline";
import ViewAll from "@/partials/elements/ViewAll";
import React from "react";

export default function BenefitsCardInfo({ item, handleModalOpen }) {
  return (
    <>
      <Headline
        text={item?.title}
        extraClass=" md:text-xl py-4  group-hover:text-white"
      />
      <Description text={item?.description} extraClass={"line-clamp-3 mb-4"} />
      <ViewAll
        text={"Learn More"}
        action={() => handleModalOpen(item?._id)}
        extraClass={"font-bold text-xl "}
      />
    </>
  );
}
